<script setup lang="ts">
/**
 * Light/dark switch.
 *
 * The icon alone is not an accessible name, so the control carries both an `aria-label` and
 * `aria-pressed`. Without `aria-pressed` a screen reader announces "toggle colour theme, button"
 * with no indication of the current state, leaving the user to guess what pressing it will do.
 */

/**
 * Vue
 */
import { useI18n } from 'vue-i18n'

/**
 * Libraries
 */
import { Moon, Sun } from '@lucide/vue'

/**
 * Composables
 */
import { useTheme } from '@bayudwiyansatria/vue'

const theme = useTheme()
const { t } = useI18n()
</script>

<template>
  <button
    type="button"
    class="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-border bg-background/60 text-foreground backdrop-blur transition hover:border-primary/40 hover:text-primary"
    :aria-label="t('actions.toggleTheme')"
    :aria-pressed="theme.isDark.value"
    @click="theme.toggle()"
  >
    <Moon v-if="theme.isDark.value" class="h-4 w-4" aria-hidden="true" />
    <Sun v-else class="h-4 w-4" aria-hidden="true" />
  </button>
</template>
